export default from './share-comment-modal';



// WEBPACK FOOTER //
// ./app/containers/share-comment-modal/index.js